import { useMemo } from 'react';
import { useAppContext } from 'Providers/AppProvider/AppContext';
import { Product } from '@setvi/shared/interfaces';
import { COMPANIES } from 'Enums/Companies';

export const useProductSpecifications = (product: Product) => {
  const { user: appUser } = useAppContext();
  const externalMiddlebyUser = appUser?.ExternalUserDomainId !== 0;
  const syscoUser = [COMPANIES.SYSCO_PROD, COMPANIES.SYSCO_DEV].includes(
    appUser.CompanyID
  );

  const currentProduct: Product = useMemo(() => {
    const value: any = { ...product };

    if (externalMiddlebyUser) {
      delete value.custom['15_for_15_product'];
    }

    // For sysco we are removing active, discountinued, In Stock, Dropship, Case Qunatity and Pack Size
    if (syscoUser) {
      const valuesToRemove = [
        'active',
        'discontinued',
        'inStock',
        'dropship',
        'caseQuantity',
        'packSize'
      ];
      valuesToRemove.forEach(i => delete value.custom[i]);
    }

    return value;
  }, [product, externalMiddlebyUser, syscoUser]);

  return {
    specifications: Object.values(currentProduct?.custom || {}).filter(
      el => el.value !== '' && el.specification && el.label
    )
  };
};
